// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import OnlinePaymentModel from '../../model/online-payment-model';
import OnlinePaymentDTO from '../dto/online-payment-dto';
import dtoSchema from '../schemas/online-payment-schema';

export default abstract class OnlinePaymentModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<OnlinePaymentDTO>) {
    super();
    if (data) {
      this.transactionId = data.transactionId ?? undefined;
      this.paymentDate = data.paymentDate;
      this.currency = data.currency ?? undefined;
      this.amount = data.amount;
    }
  }
  /**
  */
  transactionId?: string;
  /**
  * @type {date-time}
  */
  paymentDate?: string;
  /**
  */
  currency?: string;
  /**
  * @type {double}
  */
  amount?: number;

  static toModel(dto: DeepPartial<OnlinePaymentDTO>): OnlinePaymentModel;
  static toModel(dto: DeepPartial<OnlinePaymentDTO> | undefined | null): OnlinePaymentModel | undefined;
  static toModel(dto: DeepPartial<OnlinePaymentDTO> | undefined | null): OnlinePaymentModel | undefined {
    return dto ? new OnlinePaymentModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<OnlinePaymentModel> | OnlinePaymentModel): OnlinePaymentDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      transactionId: unwrapped.transactionId,
      paymentDate: unwrapped.paymentDate,
      currency: unwrapped.currency,
      amount: unwrapped.amount,
    } as OnlinePaymentDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for OnlinePaymentModel, can not map to OnlinePaymentDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
